// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import includeFullyComplete from './include-fully-complete';
import metric from './metric';
import pipNumber from './pip-number';
import pipStatuses from './pip-statuses';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import selectedDealers from './selected-dealers';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        includeFullyComplete,
        metric,
        pipNumber,
        pipStatuses,
        report,
        reportIsScrollable,
        selectedDealers,
        showNoResultsFound
    });



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/reducers/index.js